import React, { useRef, type FunctionComponent, type ReactElement } from 'react'
import { isInIframe, postNavigateMessage } from '../../utils'
import { OpenInNewIcon, StyledLink } from './iframe-link.styles'

export type IframeLinkProps = {
	href: string,
	children: ReactElement | String,
	target?: '_blank' | '_self' | '_parent' | '_top',
	onClick?: () => void,
}

export const IframeLink: FunctionComponent<IframeLinkProps> = ( {
	children,
	href,
	target = '_self',
	onClick,
} ) => {
	const isInAnIframe = useRef( isInIframe() ).current

	const onClickInside = ( event: React.MouseEvent<HTMLAnchorElement> ) => {
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		if ( isInAnIframe ) {
			event.preventDefault()

			postNavigateMessage( href, target )
		}

		if ( onClick ) {
			onClick()
		}
	}

	return (
		<StyledLink
			onClick={onClickInside}
			href={href}
			target={target}
			aria-label={
				target === '_blank'
					? '(opens in a new tab)'
					: undefined
			}
			noWrap
		>
			{children}{target === '_blank' && <OpenInNewIcon />}
		</StyledLink>
	)
}
